export const getReparentAction = (parentId?: string, parentIdOld?: string) => {
	if (!parentId) {
		return 'removeParent';
	}
	if (parentIdOld) {
		return 'changeParent';
	}
	return 'addParent';
};
